import { render, staticRenderFns } from "./404page.vue?vue&type=template&id=0926a6be&scoped=true&"
var script = {}
import style0 from "./404page.vue?vue&type=style&index=0&id=0926a6be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0926a6be",
  null
  
)

export default component.exports